import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { ContractCreationType } from './contract-creation-type.interface';
import contractCreationTypeService from './contract-creation-type.service';

export interface ContractCreationTypeState {
   contract_creation_types: Array<ContractCreationType>;
}

const ContractCreationTypeStore: Module<ContractCreationTypeState, StoreState> = {
   namespaced: true,
   state: {
      contract_creation_types: [],
   },

   getters: {},

   mutations: {
      SET_CONTRACT_CREATION_TYPES(state, { contract_creation_types }: { contract_creation_types: Array<ContractCreationType> }) {
         state.contract_creation_types = contract_creation_types;
      },
   },

   actions: {
      async get({ commit }) {
         await contractCreationTypeService
            .get()
            .then((response) => commit('SET_CONTRACT_CREATION_TYPES', { contract_creation_types: response.data }));
      },
   },
};

export default ContractCreationTypeStore;
